export const HOST_API = process.env.REACT_APP_HOST_API_KEY || 'http://localhost:8000';
export const STRIPE_PUBLIC_KEY = process.env.STRIPE_PUBLIC_KEY || 'pk_test_51QWPz4GMkkAWfhlOFzr5iOxe98NX3FcYzAw9EnjJnI0W3jtBnxCrh4Cl36GOcKkzrsPFxuoD1z9MM8cPVYUm1r3U00pzyPY7WM';
export const STRIPE_PROD_KEY = process.env.STRIPE_PROD_KEY || 'prod_U8j2Srdwg1moJ1';
export const STRIPE_PRICE_KEY = process.env.STRIPE_PRICE_KEY || 'price_1TARaLGMkkAWfhlOBiwZobj2';
